import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { UserScope } from 'src/app/core/interfaces/user-scope';
import { DepartmentModel } from 'src/app/core/models/department-model';
import { ScopeService } from 'src/app/core/services/scope.service';

@Component({
  selector: 'app-select-department-dialog',
  templateUrl: './select-department-dialog.component.html',
  styleUrls: ['./select-department-dialog.component.scss']
})
export class SelectDepartmentDialogComponent implements OnInit {

  userScope: UserScope;
  selectedDepartmentID: ""; 
  departments:DepartmentModel[] = [];

  constructor(
    public dialogRef: MatDialogRef<SelectDepartmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,         
    public translate: TranslateService,
    private scopeService: ScopeService
  ) { 
   
    this.userScope = this.scopeService.userScope;
  }

  ngOnInit(): void {
    this.departments = this.userScope.departments || [];

  }

  onSave(event){
    this.dialogRef.close({ canceled: false, departmentID: this.selectedDepartmentID});
  }

  onCancel(event){
    this.dialogRef.close({ canceled: true, departmentID: ''});
  }



}
